export default "__VITE_ASSET__CP0b8o7n__"